import styled from "styled-components";
import { BundlePriceProps } from "./types";

const StyledBundlePrice = styled.div`
  align-items: center;
  background-position: 50%;
  border-radius: 18px;
  bottom: 12px;
  display: flex;
  height: 40px;
  justify-content: center;
  left: 50%;
  position: absolute;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  background: ${(props: any) => props.buttonColor};
  color: ${(props: any) => props.buttonTextColor};
  width: 120px;
  z-index: 2;
  background-size: cover;
` as any;

const BundlePrice = ({
  price,
  currency = "USD",
  buttonColor,
  buttonTextColor,
}: BundlePriceProps) => {
  return (
    <StyledBundlePrice
      buttonColor={buttonColor}
      buttonTextColor={buttonTextColor}
    >
      {new Intl.NumberFormat("en-US", {
        style: "currency",
        currency,
      })
        .format(price)
        .replace(/\D00(?=\D*$)/, "")}
    </StyledBundlePrice>
  );
};

export default BundlePrice;
